import { UserRoles } from '@cloud-wave/neon-common-lib';

export const supervisorOrAdmin = [UserRoles.ADMIN, UserRoles.SUPERVISOR];
export const adminOnly = [UserRoles.ADMIN];
export const anyValidUser = [];
